import styled from "styled-components";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import { getUUID } from "../../utility";
import Container from "../UI/Container/Container";

const blue = "rgb(0, 79, 139)";
const white = "rgb(255,255,255)";

const StyledBoxes = styled.div`
  display: flex;
  gap: 15px;
  transform: translateY(-50%);
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  @media (max-width: 992px) {
    flex-direction: column;
    transform: translateY(-15%);
  }
`;

const Box = styled.div`
  width: 100%;
  background-color: ${blue};
  padding: 25px;
  box-sizing: border-box;
`;

const Title = styled.div`
  text-transform: uppercase;
  text-align: center;
  font-size: 32px;
  color: ${white};
  font-weight: 100;
`;

const Text = styled.div`
  text-align: center;
  color: ${white};
  margin-top: 15px;
  font-weight: 100;
`;

const CareerBoxes = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Container>
      <StyledBoxes>
        {t.career.boxes.map((box: { title: string; text: string }) => (
          <Box key={getUUID()}>
            <Title>{box.title}</Title>
            <Text>{box.text}</Text>
          </Box>
        ))}
      </StyledBoxes>
    </Container>
  );
};

export default CareerBoxes;
